import { Tag } from "../lib/Tag.tsx";
import type { AttributionPanelModel } from "./work.model.ts";

/**
 * WHO MADE THIS, AND WHETHER ANYBODY WITH AUTHORITY AGREES — OND-20.
 *
 * Directly under the catalogue facts, above the code, because it is the
 * question every other claim on the record hangs off: a chain of title is a
 * chain of title to something, and whose work that something is, is the first
 * thing a collector asks.
 *
 * IT RENDERS AND DECIDES NOTHING. Which sentence to print — and in particular
 * that a studio which was asked and declined must not read as "nobody has been
 * asked" — is `describeAttribution`. Every condition below is the presence or
 * absence of a value the model already chose, never a rule about the domain.
 */
export function WorkAttributionPanel({
  panel,
  onAsk,
  onOpenEntry,
}: {
  panel: AttributionPanelModel;
  /** Opens the add-history modal on the Artist attribution chip. */
  onAsk: () => void;
  /** Lands the reader on the claim's own row, where the request door is. */
  onOpenEntry: (entryId: string) => void;
}) {
  // Captured so the handler closes over a narrowed value rather than re-reading
  // a nullable field inside the callback.
  const entry = panel.entry;

  return (
    <section className="work__attribution-panel">
      <h3 className="work__attribution-title">{panel.title}</h3>

      {panel.tag && <Tag tone={panel.tag.tone}>{panel.tag.label}</Tag>}

      {panel.claim !== null && (
        <p className="work__attribution-claim">{panel.claim}</p>
      )}
      {panel.claimNote !== null && (
        <p className="work__attribution-note">{panel.claimNote}</p>
      )}

      <p className="work__attribution-line">{panel.line}</p>
      {panel.detail !== null && (
        <p className="work__attribution-note">{panel.detail}</p>
      )}

      {panel.ask !== null && (
        <button type="button" className="work__attribution-ask" onClick={onAsk}>
          {panel.ask}
        </button>
      )}

      {entry !== null && (
        <button
          type="button"
          className="work__attribution-open"
          onClick={() => onOpenEntry(entry.id)}
        >
          {entry.label}
        </button>
      )}
    </section>
  );
}
